// src/pages/InvestverseSneakPeek.js
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Container, Typography, Button, Box } from "@mui/material";

function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date("2026-04-15T00:00:00"); // launch date
    const interval = setInterval(() => {
      const now = new Date();
      const diff = targetDate - now;

      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Typography variant="h6" sx={{ mt: 4 }}>
      Launching in {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m{" "}
      {timeLeft.seconds}s
    </Typography>
  );
}

function InvestverseSneakPeek() {
    const navigate = useNavigate(); 
  return (
    <Container sx={{ py: 8, textAlign: "center" }}>
      {/* Hero Section */}
      <Typography variant="h3" gutterBottom sx={{ fontWeight: "bold" }}>
        Welcome to <span style={{ color: "#4caf50" }}>Investverse</span>
      </Typography>
      <Typography variant="h6" sx={{ mb: 4, color: "gray" }}>
        The future of investing is closer than you think...
      </Typography>

      {/* Blurred Mystery Cards */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 3,
          mt: 6,
        }}
      >
        {[1, 2, 3].map((i) => (
          <Box
            key={i}
            sx={{
              width: 200,
              height: 120,
              background: "linear-gradient(135deg, #222, #444)",
              borderRadius: 2,
              filter: "blur(4px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: "bold",
            }}
          >
            Hidden Feature {i}
          </Box>
        ))}
      </Box>

      {/* Countdown Timer */}
      <Countdown />

      {/* Pulsing Banner */}
      <Typography
        variant="h5"
        sx={{
          mt: 6,
          animation: "pulse 2s infinite",
          "@keyframes pulse": {
            "0%": { opacity: 0.3 },
            "50%": { opacity: 1 },
            "100%": { opacity: 0.3 },
          },
          color: "#4caf50",
          fontWeight: "bold",
        }}
      >
        🚀 Coming Soon...
      </Typography>

      {/* CTA Button */}
      <Button
        variant="contained"
        color="success"
        size="large"
        sx={{ borderRadius: "30px", px: 4, mt: 4 }}
        onClick={() => navigate("/waitlist")}
      >
        Join the Waitlist
      </Button>

      {/* Footer Teaser */}
      <Typography variant="caption" display="block" sx={{ mt: 4, color: "gray" }}>
        Curiosity is the first step to discovery...
      </Typography>
    </Container>
  );
}

export default InvestverseSneakPeek;
